/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlannerIssueListEmbedPageQuery } from './__generated__/PlannerIssueListEmbedPageQuery.graphql.ts';
import { plannerIssueListEmbedPreloadEntryPoint } from './plannerIssueListEmbedPreloadEntryPoint.tsx';
import type { PlannerIssueListEmbedEntryPoints } from './plannerIssueListEmbedEntryPoint.entrypoint.types.tsx';

type Queries = {
	issueListQueryRef: PlannerIssueListEmbedPageQuery;
};

type ExtraProps = {
	jql: string;
};

type PlannerIssueListEmbedEntryPointComponent = EntryPointComponent<
	Queries,
	PlannerIssueListEmbedEntryPoints,
	{},
	ExtraProps
>;

export const plannerIssueListEmbedEntryPoint: EntryPoint<
	PlannerIssueListEmbedEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<PlannerIssueListEmbedEntryPointComponent>(
		/* webpackChunkName: "async-planner-issue-list-embed" */ './PlannerIssueListEmbedPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: plannerIssueListEmbedPreloadEntryPoint,
});
